import actionTypes from '../constants/action-types';

const updateSettings = (
  settings,
  updateGlobals = true,
  updateCopyrightGlobal = false,
  options = {}
) => ({
  type: actionTypes.UPDATE_SETTINGS,
  payload: {
    settings,
    updateGlobals,
    updateCopyrightGlobal,
    options,
  },
});

export default updateSettings;
